import React from "react"

import { ChatBotFlowBlockRule } from "@/protocols/chatBot"
import BlockBodySection from "@/pages/Admin/Flow/FlowConstructor/FlowEditor/components/BlockBodySection"
import BlockBodySectionRequiredCondition, { ContinueConditionIcon } from "@/pages/Admin/Flow/FlowConstructor/FlowEditor/components/BlockBodySectionRequiredCondition"
import BlockBodySectionHandle from "@/pages/Admin/Flow/FlowConstructor/FlowEditor/components/BlockBodySectionHandle"

import { getConditionByValidationSlug } from "@/pages/Admin/Flow/FlowConstructor/FlowEditor/utils/chatBotFlowBlockRule"

type UnsupportedMessageTypeConditionSectionProps = {
	nextChatBotFlowBlockRules: ChatBotFlowBlockRule[]
	text: string
}

const UnsupportedMessageTypeConditionSection: React.FC<UnsupportedMessageTypeConditionSectionProps> = (props) => {
	const {
		nextChatBotFlowBlockRules,
		text
	} = props

	const unsupportedMessageTypeCondition = getConditionByValidationSlug("unsupported-message-type", nextChatBotFlowBlockRules)

	if (!unsupportedMessageTypeCondition) {
		return null
	}

	return (
		<BlockBodySection>
			<BlockBodySectionHandle
				chatBotFlowBlockRule={unsupportedMessageTypeCondition.rule}
			>
				<BlockBodySectionRequiredCondition
					text={text}
					icon={<ContinueConditionIcon />}
				/>
			</BlockBodySectionHandle>
		</BlockBodySection>
	)
}

export default UnsupportedMessageTypeConditionSection
